export default __webpack_public_path__ + "static/media/img1.86b4c004.PNG";